import { ref } from 'vue'
import { getValueByPath } from 'pangu-core'

// const __CACHE_DURATION__ = 60 * 60 * 6 // 缓存 6 小时

export function useSelected({ props, tableRef }) {
  const data = new Map()
  const selected = ref([]) // 已选中的数据
  const serialNumbers = ref([]) // 已选中的序列号

  const getTableData = () => {
    if (tableRef.value) {
      return tableRef.value.getTableData()
    }

    return { fullData: [], pageData: [] }
  }

  // 手动选中/取消表格行数据
  const setCheckboxRow = async (row, checked) => {
    checkboxChange({ row, checked })
    tableRef.value?.setCheckboxRow(row, checked)
  }
  // 手动全选/取消表格所有行数据
  const setAllCheckboxRow = async (checked) => {
    if (getTableData) {
      const { pageData } = getTableData()
      checkboxAll({ checked, records: pageData })
    }
    tableRef.value?.setAllCheckboxRow(checked)
  }

  const saveSerialStorage = (record) => {
    const serialNumber = getValueByPath(record, props.valKey)
    if (serialNumbers.value?.length) {
      serialNumbers.value = [...new Set(serialNumbers.value.concat([serialNumber]))]
    } else {
      serialNumbers.value = [serialNumber]
    }
  }
  const saveAllSerialStorage = (val) => {
    serialNumbers.value = val
  }
  const removeSerialStorage = (record) => {
    if (!serialNumbers.value?.length) return
    const serialNumber = getValueByPath(record, props.valKey)
    const delIndex = serialNumbers.value.findIndex(
      (__serialNumber) => __serialNumber === serialNumber
    )
    if (delIndex > -1) serialNumbers.value.splice(delIndex, 1)
  }

  const __updateDataAndSelected = (record) => {
    if (!(selected.value instanceof Array)) throw '--Error-selected-isNotArray'
    if (record?._ID) {
      selected.value = [...new Set([...selected.value, record._ID])]
      data.set(record._ID, record)
      saveSerialStorage(record)
    }
  }
  // 全部选中时更新已选中的数据
  const __updateSelected = (record) => {
    if (record instanceof Array) {
      record?.map(__updateDataAndSelected)
    } else {
      __updateDataAndSelected(record)
    }
  }
  // 查找在 selected 中的索引
  const __searchIndex = (_ID) => selected.value.findIndex((id) => id === _ID)
  // 删除指定的数据
  const __removeSelected = (record) => {
    if (!(selected.value instanceof Array)) throw '--Error-selected-isNotArray'
    if (record?._ID) {
      const delIndex = __searchIndex(record._ID)
      if (delIndex > -1) {
        data.delete(record._ID)
        selected.value.splice(delIndex, 1)
        removeSerialStorage(record)
      }
    }
  }
  // 清空已选中
  const __clearAllSelected = () => {
    data.clear()
    selected.value = []
    serialNumbers.value = []
  }

  const checkboxChange = (param) => {
    if (param?.checked) {
      // 选中
      __updateSelected(param?.row)
    } else {
      // 取消选中
      __removeSelected(param?.row)
    }
  }
  const checkboxAll = (param) => {
    if (param?.checked) {
      // 全部选中
      __updateSelected(param?.records)
    } else {
      // 全部取消
      __clearAllSelected()
    }
  }
  return {
    serialNumbers,
    tableRef,
    selected,
    data,
    checkboxChange,
    checkboxAll,
    setCheckboxRow,
    setAllCheckboxRow,
    saveAllSerialStorage,
    getTableData,
  }
}
